import { render, staticRenderFns } from "./SeguimientosPagination.vue?vue&type=template&id=36d0f71a&"
import script from "./SeguimientosPagination.vue?vue&type=script&lang=js&"
export * from "./SeguimientosPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports